import "babel-polyfill";

import React from "react";
import ReactDOM from "react-dom";
import "./_index.scss";

import * as serviceWorker from "./serviceWorker";
import App from "./app/App";
import { SnackbarProvider } from "notistack";
// cssVars();

if (process.env.NODE_ENV === "development") {
  const dismissStuckOverlay = () => {
    ["react-error-overlay", "webpack-dev-server-client-overlay"].forEach(
      id => {
        const el = document.getElementById(id);
        if (el) {
          el.remove();
        }
      }
    );
    document.querySelectorAll("body > iframe").forEach(frame => {
      const zIndex = Number(frame.style.zIndex);
      if (frame.style.position === "fixed" && zIndex >= 1000) {
        frame.remove();
      }
    });
  };

  window.addEventListener(
    "error",
    event => {
      const message = event.message || "";
      if (
        message.includes("Can't find variable: process") ||
        message.includes("process is not defined")
      ) {
        event.preventDefault();
        dismissStuckOverlay();
      }
    },
    true
  );
}

ReactDOM.render(
  <SnackbarProvider>
    <App />
  </SnackbarProvider>,
  document.getElementById("root")
);

// for IE-11 support un-comment cssVars() and it's import in this file
// and in MatxTheme file

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
